import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";
export function useFetchDetailsApiArguments(
  email,
  submittedFormData,
  selectedFeeCodes
) {
  const apiUrl = "api/FeeAndAdjustment/GetDetails";

  let apiParams = {};

  if (
    !IsNullOrEmpty(email) &&
    !IsNullOrEmpty(selectedFeeCodes) &&
    !IsNullOrEmpty(submittedFormData)
  ) {
    apiParams = {
      user: email,
      fromDate: submittedFormData.fromDate,
      toDate: submittedFormData.toDate,
      locations: submittedFormData.locations,
      payers: submittedFormData.payers,
      checkNumber: submittedFormData.checkNumber,
      status: submittedFormData.remitStatus,
      feeCodes: selectedFeeCodes,
    };
  }

  return { apiUrl, apiParams };
}
